import React, { Component } from "react";

import "./index.scss";

export default class Bottombar extends Component {
	render() {
		return (
			<div className="bottombar-component center tac">
				<h3>
					<a href="//www.163.com/special/0077450P/feedback_window.html">意见反馈</a>
				</h3>
				<ul>
					<li><a href="//corp.163.com">About NetEase</a></li>
					<li>-</li>
					<li><a href="http://gb.corp.163.com/gb/about/overview.html">公司简介</a></li>
					<li>-</li>
					<li><a href="//corp.163.com/gb/contactus.html">联系方法</a></li>
					<li>-</li>
					<li><a href="//corp.163.com/gb/job/job.html">招聘信息</a></li>
					<li>-</li>
					<li><a href="//help.163.com">客户服务</a></li>
					<li>-</li>
					<li><a href="//d.163.com/webapp/user-terms/privacy-policy.html">凯恩之角隐私政策及儿童个人信息保护规则</a></li>
					<li>-</li>
					<li><a href="http://emarketing.biz.163.com">网络营销</a></li>
					<li>-</li>
					<li><a href="//sitemap.163.com">网站地图</a></li>
				</ul>
				<p>网易公司版权所有</p>
				<small>©1997-2025</small>
			</div>
		);
	}
}